import { Center, Flex, Text } from '@chakra-ui/react';
import { decode } from 'js-base64';
import { Announcement01 } from '@kula-ai/icons-core';
import { KButton } from '@/ui-library/components';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { NotificationLink } from '../../components/NotificationLink';

interface Notification {
  id?: string | number;
  custom_attributes?: string;
  [key: string]: any;
}

interface Props {
  notification?: Notification;
  onClose?: () => void;
}

export const CandidateConsentRecruiterContactedNotification = ({
  notification = {},
  onClose = () => {},
}: Props) => {
  const [markAsRead] = useMarkAsReadMutation();
  let data: {
    candidate?: { id?: number; name?: string };
    content?: { body?: string };
  } = {};
  try {
    data = JSON.parse(decode(notification.custom_attributes || ''));
  } catch (error) {
    console.error('Error decoding consent contacted notification:', error);
  }

  const { candidate = {}, content = {} } = data;

  const viewCandidate = () => {
    markAsRead({ id: notification?.id });
    window.open(`/candidates/${candidate.id}`, '_self');
    onClose();
  };

  return (
    <NotificationCard notification={notification}>
      <Flex alignItems="baseline" gap="6px">
        <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
          <Announcement01
            size="1em"
            color="var(--kula-colors-primary-500)"
            className="kula-icon"
          />
        </Center>
        <Flex flexDir="column" ml="12px" gap="8px" alignSelf="start" flex="1">
          <Text fontSize="sm">
            You have a message from
            <NotificationLink
              to={`/candidates/${candidate.id}`}
              label={candidate.name}
              onClose={onClose}
              notification={notification}
              data-test-id="candidate-link"
            />
          </Text>

          {content.body && (
            <>
              <Text
                size="sm-bold"
                color="secondary-700"
                textTransform="uppercase"
              >
                Message
              </Text>
              <Text fontSize="sm">{content.body}</Text>
            </>
          )}

          <NotificationTime notification={notification} />
          {candidate.id && (
            <KButton
              w="fit-content"
              variant="primary"
              borderRadius="8px"
              maxH="34px"
              onClick={viewCandidate}
              data-test-id="view-candidate-button"
            >
              View candidate
            </KButton>
          )}
        </Flex>
      </Flex>
    </NotificationCard>
  );
};
